<template>
    <a
        :href="panicButtonUrl"
        target="_blank"
        class="panic-button"
        v-if="(isMobile || isLandscape) && useNgSession().isLoggedIn.value"
    >
        <HeaderLoggedDuration> Čas přihlášení: </HeaderLoggedDuration>
        <div>
            <SvgIcon name="zablokovat-hrani-fill" :size="12" />
            Vyloučit se z hraní
        </div>
    </a>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { useNgSession } from "@/shared/ng/ng-session";
import HeaderLoggedDuration from "@/header/components/atoms/HeaderLoggedDuration.vue";

const { isMobile, isLandscape } = useIsBreakpoint();

const panicButtonUrl = computed(() => {
    return `${environment.portalBaseUrl}?panic-button=true`;
});
</script>
